export class FeedbackManagerUtil {
  private static _instance: FeedbackManagerUtil;

  private constructor() {
    // Private constructor to enforce singleton pattern
  }

  static get instance(): FeedbackManagerUtil {
    if (!FeedbackManagerUtil._instance) {
      FeedbackManagerUtil._instance = new FeedbackManagerUtil();
    }
    return FeedbackManagerUtil._instance;
  }

  mergeQuestionsAndResponses(questions: string[], responses: string[]): Record<string, string> {
    return questions.reduce<Record<string, string>>((dict, question, index) => {
      dict[`${index + 1}. ${question}`] = responses[index];
      return dict;
    }, {});
  }
}

export const getFeedbackManagerUtil = (): FeedbackManagerUtil => FeedbackManagerUtil.instance;
